import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import firebase from 'firebase';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers

const MainLayout = React.lazy(() => import('./main/MainLayout'));
const Prompter = React.lazy(() => import('./views/showflows/Prompter'));
const Director = React.lazy(() => import('./views/showflows/Director'));
const OBSListener = React.lazy(() => import('./views/showflows/OBSListener'));
const Hook = React.lazy(() => import('./views/integrate/Hook'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {

  componentDidMount() {
    this.mainFirebase();
  }

  mainFirebase() {
    const firebaseConfig = {
      apiKey: "AIzaSyADZoH_-kJlCQgBgAMVwiidV0ZUk0q0Khc",
      authDomain: "protools-73db6.firebaseapp.com",
      projectId: "protools-73db6",
      storageBucket: "protools-73db6.appspot.com",
      messagingSenderId: "612359752021",
      appId: "1:612359752021:web:2b18844aba5dd4942187dc",
      measurementId: "G-459526SR5F"
    };
    // Initialize Firebase

    if (firebase.apps.length <= 0) {
      firebase.initializeApp(firebaseConfig);
    }
  }

  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
            <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
            <Route exact path={'/programs/view/:id/showflow/prompter/:type'} name="Prompter" render={props => <Prompter {...props}/>} />
            <Route exact path={'/programs/view/:id/showflow/director/:type'} name="Director" render={props => <Director {...props}/>} />
            <Route exact path={'/programs/view/:id/showflow/obs/:type'} name="OBS" render={props => <OBSListener {...props}/>} />
            <Route exact path={'/hook/:id/:type'} name="Hook" render={props => <Hook {...props}/>} />
            <Route path="/" name="Programs" render={props => <MainLayout {...props}/>} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
